import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  WritableSignal,
  signal,
} from '@angular/core';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { buildPayload, Translation } from '@ckmk/angular';
import { SolutionCard } from '@app/src/app/modules/solution/components/solution-card/solution-card';
import { SolutionService } from '@app/src/app/modules/solution/service/solution.service';

@Component({
  selector: 'solutions-home-container',
  standalone: true,
  imports: [Translation, SolutionCard],
  templateUrl: './solutions-home-container.html',
  styleUrl: './solutions-home-container.scss',
  host: {
    '[class.hidden]': 'itemsEmpty()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class SolutionsHomeContainer
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly service = inject(SolutionService);

  protected readonly solutions: WritableSignal<SolutionModel[]> = signal<
    SolutionModel[]
  >([]);

  protected readonly itemsEmpty: WritableSignal<boolean> =
    signal<boolean>(true);

  public constructor() {}

  public ngOnInit(): void {
    this.service.solutions.onQuery((result, loading) => {
      if (!loading && result) {
        this.solutions.set(result);

        this.itemsEmpty.set(result.length === 0);
      }
    });

    this.fetchSolutions();
  }

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy(): void {
    this.service.solutions.unsubscribe();
  }

  public ngAfterContentInit(): void {}

  protected fetchSolutions(): void {
    this.service.solutions.watchQuery(
      buildPayload()
        .into('payload', (builder) =>
          builder
            .paginate(1, 3)
            .sort({
              createdAt: 'DESC',
            })
            .filters((filter) => filter.equalTo('active', true))
            .setMultiple({
              includeCategory: true,
              includePicture: true,
            }),
        )
        .build(),
    );
  }
}
